import React, { useEffect, useState } from "react";
import {
  Stack,
  PrimaryButton,
  IButtonStyles,
  mergeStyles,
} from "office-ui-fabric-react";
import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";
import { validationSchemaNipNotRequired } from "../../../actions/validationSchema";
import { useVerification } from "../../../hooks/useVerification";
import ActivityIndicator from "../../../../common/layout/ActivityIndicator";
import NewFormField from "../../../../common/layout/form/NewFormField";
import MessageContainer from "./MessageContainer";
import { LangEnum } from "../../../../common/enums/lang.enum";
import FormDropDown from "../../../../common/layout/form/FormDropDown";

const formS = {
  height: "100%",
};

const buttonS: Partial<IButtonStyles> = {
  root: {
    width: "200px",
    position: "absolute",
    bottom: 30,
    left: 40,
  },
};

const padding = mergeStyles({
  paddingTop: 15,
});

export interface IInitValues {
  nip: string;
  country: number;
}

const initValues = {
  nip: "",
  country: LangEnum.Polish
};

const NipForm: React.FC = () => {
  const { t } = useTranslation("admin");
  const { handleVerification, loading } = useVerification();

  const [lang, setLang] = useState<LangEnum>(LangEnum.Polish)

  return (
    <>
      <Formik
        initialValues={initValues}
        onSubmit={handleVerification}
        validateOnBlur = {true}
        validateOnChange = {true}
        validationSchema={lang == LangEnum.Polish ? validationSchemaNipNotRequired : undefined}
      >
        {({ handleSubmit }) => (
          <Form translate="yes" onSubmit={handleSubmit} style={formS}>
            <Stack verticalFill verticalAlign="start" horizontalAlign="start">
              <NewFormField
                name="nip"
                label={t("auth.formLabels.nip") as string}
                required={false}
              />
              <FormDropDown
                name={"country"}
                headerText={t("nav.country") as string}
                options={[
                  { key: LangEnum.Polish, text: t("nav.countryPoland") as string },
                  // { key: 2, text: "Anglia" },
                  { key: LangEnum.German, text: t("nav.countryGermany") as string },
                  { key: LangEnum.Slovak, text: t("nav.countrySlovakia") as string },
                  { key: LangEnum.Estonian, text: t("nav.countryEstonia") as string },
                  { key: LangEnum.Czech, text: t("nav.countryCzech") as string }
                ]}
                onChange={setLang}
              />
              <PrimaryButton
                text={t("nav.next") as string}
                styles={buttonS}
                type="submit"
              />

              <div className={padding}>
                {loading ? <ActivityIndicator /> : <MessageContainer />}
              </div>
            </Stack>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default NipForm;